export interface BIDPACK_ORIGIN_INTERFACE {
    CountryID:number,OriginCountry:string, OriginPostcodeArea:string, OriginPostCode:string, OriginGSDB:string, 
    BidPackID:number,  Selected?:boolean, UserEmail:string
}

export interface BIDPACK_TABLE_INTERFACE {
    BidPackID: number, BidPackReference: string, Selected?: boolean
    BidPackName: string, BidPackTypeID: number, BidPackType: number, 
    DestinationName: string, CreatedOn: string, ModifiedOn: string, IsActive:boolean
}

export const bidpack_column_order_overview = [
    {name:"BidPackStatus",displayName:'Status' , order : 1},
    {name:"BidPackReference",displayName:'Bid Pack Reference' , order : 2},
    {name:"BidPackName",displayName:'Bid Pack Name' , order : 3},
    {name:"BidPackType",displayName:'Bid Pack Type' , order: 4},
    {name:"OriginCountry",displayName:'Origin Country' , order : 5},
    {name:"DestinationName",displayName:'Destination Name' , order : 6},
    {name:"CreatedOn",displayName:'Created (Date/Time)' , order : 7},
    {name:"ModifiedOn",displayName:'Modified (Date/Time)' , order : 8},
]
export const bidpack_column_edit = [
    {name:"DestinationName", displayName:'Destination Name' , order : 1},
    {name:"CreatedOn", displayName:'Start Date' , order : 2},
    {name:"enddate", displayName:'End Date' , order : 3},
    {name:"assignedCarrier",displayName:'Assigned Carrier' , order: 4},
    {name:"assignedRateAgreement", displayName:'Assigned Rate Agreement' , order : 5},
    {name:"TT", displayName:'TT' , order : 6},
    {name:"CB", displayName:'CB' , order : 7},
    {name:"BidPackStatus", displayName:'Status' , order : 8},
    {name:"EquipmentType", displayName:'Equipment Type' , order : 9},
    {name:"OriginCountry", displayName:'Country' , order : 10},
    {name:"OriginPostcodeArea", displayName:'Postcode Area' , order : 11},
    {name:"OriginPostCode", displayName:'Postcode' , order : 12},
    // {name:"OriginGSDB", displayName:'Supplier GSDB' , order : 13},
    // {name:"DestinationType", displayName:'Destination Type'  , order : 14},
    // {name:"DestinationGSDB", displayName:'Destination GSDB'  , order : 15},
]